export default __webpack_public_path__ + "static/media/profile.d7634b6e.svg";